import { Box, Button, Divider, Typography } from "@mui/material";
 
export const DeleteConfirmation = ({ deleting, onConfirm, onCancel, message }: { deleting: boolean; onConfirm: () => void; onCancel: () => void; message?: string }) => {
    return (
        <Box>
            <Typography variant="body2" px={5} py={3}>
                {message || "Are you sure you want to delete this item?"}
            </Typography>
            <Divider />
            <Box display="flex" justifyContent="flex-end" gap={2} p={2}>
                <Button variant="outlined" onClick={onCancel} disabled={deleting}>
                    Cancel
                </Button>
                <Button variant="contained" color="error" onClick={onConfirm} disabled={deleting}>
                    Delete
                </Button>
            </Box>
        </Box>
    );
};
 